import { memo } from "react";
import PropTypes from "prop-types";
import { isEmpty, isEqual } from "lodash";
import DailyCalendarTile from "./dailyCalendarTile/dailyCalendarTile";
import {
  calculateEventHeight,
  calculateEventTop,
} from "../../../../utils/edReviewUtils";
import { OFFSET, SLOT_HEIGHT } from "../edReviewCalendarDaily";

const BarsLockedSlots = ({ events, date, colWidth }) => {
  return (
    !isEmpty(events) &&
    events.map((event, colIndex) => {
      return (
        <DailyCalendarTile
          id={`${event?.__id}${event?.start}`}
          key={`${event?.__id}${event?.start}`}
          event={event}
          options={{
            top: calculateEventTop({
              event,
              slotHeight: SLOT_HEIGHT,
              offset: OFFSET,
              eventDate: date,
              isReview: false,
              isBars: true,
            }),
            left: 0,
            height: calculateEventHeight({
              event,
              eventSlotHeight: SLOT_HEIGHT,
              offset: OFFSET,
              eventDate: date,
              isReview: false,
              isBars: true,
            }),
            width: colWidth,
          }}
        />
      );
    })
  );
};

BarsLockedSlots.propTypes = {
  date: PropTypes.string,
  events: PropTypes.array,
  colWidth: PropTypes.string,
};

export default memo(BarsLockedSlots, isEqual);
